// extracted by mini-css-extract-plugin
module.exports = {"bottomBanner":"Banner_bottomBanner__aiM5C"};